export default __webpack_public_path__ + "static/media/mobile_terms_moreBtn.472a9ecd.svg";